export default __webpack_public_path__ + "static/media/text-instruction.163011ba.svg";